import React, { useEffect, useState, Fragment } from "react";
import { Link, withRouter, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createHead2, getCurrentHead2 } from "../../actions/content/head2";

const CreateHead2 = ({
  createHead2,
  getCurrentHead2,
  head2: { head2, loading },

  history
}) => {
  const [formData, setFormData] = useState({
    title: ""
  });

  const [displaySocialInputs, toggleSocialInputs] = useState(false);
  const { title } = formData;
  const onChange = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });
  const onSubmit = e => {
    e.preventDefault();
    createHead2(formData, history);
  };
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return loading && head2 === null ? (
    <Redirect to="/dashboard" />
  ) : (
    <Fragment>
      <h1 className="large text-primary">Add a Subtopic</h1>

      <p className="lead">
        <i class="far fa-plus-square"></i> Let's get some information to create
        a new one
      </p>

      <form className="form" onSubmit={e => onSubmit(e)}>
        <div className="form-group">
          <input
            type="text"
            placeholder="Title"
            name="title"
            value={title}
            onChange={e => onChange(e)}
            isRequired
          />
          <small className="form-text">Enter the new Category Title</small>
        </div>

        <input type="submit" className="btn btn-primary my-1" />
        <Link className="btn btn-light my-1" to="/head2-page">
          Go Back
        </Link>
      </form>
    </Fragment>
  );
};

CreateHead2.propTypes = {
  createHead2: PropTypes.func.isRequired,
  getCurrentHead2: PropTypes.func.isRequired,
  head2: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  head2: state.head2
});
export default connect(mapStateToProps, { createHead2, getCurrentHead2 })(
  withRouter(CreateHead2)
);
